const state = () => ({
  basicPage: null,
  featured: null,
  insights: null,
  horizonScanning: null,
  regulatoryAnalysis: null,
  guides: null,
  filters: null,
  picks: null,
  recommended: null,
  hot: null,
  watchlistTags: null,
  watchlist: null,
  specialism: [
    {
      name: "Responsible Gambling",
      tid: 38,
      count: 961,
      category: "specialism",
    },
    {
      name: "Licensing Requirements",
      tid: 33,
      count: 934,
      category: "specialism",
    },
    {
      name: "Advertising Regulation ",
      tid: 28,
      count: 674,
      category: "specialism",
    },
  ],
  sector: [
    {
      name: "Online Gambling",
      tid: 18,
      count: 3189,
      category: "sector",
      width: 100,
    },
    {
      name: "Sports Betting",
      tid: 1,
      count: 1964,
      category: "sector",
      width: 61.58670429601756,
    },
    {
      name: "Casinos",
      tid: 3,
      count: 1124,
      category: "sector",
      width: 35.2461586704296,
    },
  ],
  userReports: [],
  researchResearch: [],
  researchCalendar: [],
});

const getters = {};

const mutations = {
  setData(state, data) {
    state[data.label] = data.data;
  },
  removeData(state, data) {
    const objWithIndex = state[data.label].findIndex(
      (obj) => obj.id === data.data
    );
    console.log(objWithIndex, data.data);
    if (objWithIndex > -1) {
      state[data.label].splice(objWithIndex, 1);
    }
  },
};

const actions = {
  async getStaticData({ commit, state }, { url }) {
    const body = {
      method: "GET",
      url: `${this.$config.jsonApiURL}${url}`,
    };
    return await this.$axios(body)
      .then((data) => data)
      .catch((response) => console.error(response, url));
  },
  async getData({ commit, state }, { url, token }) {
    const body = {
      method: "GET",
      url: `${this.$config.jsonApiURL}${url}`,
    };
    // if (token) body.headers = { Authorization: `Bearer ${token}` }
    return await this.$axios(body)
      .then((data) => data)
      .catch(({ response }) => {
        // console.log(response, url, "DEBUGA");
      });
  },
  async getViewData({ commit, state }, { url, token }) {
    const body = {
      method: "GET",
      url: `${this.$config.apiURL}${url}`,
    };
    // if (token) body.headers = { Authorization: `Bearer ${token}` }
    return await this.$axios(body)
      .then((data) => data)
      .catch(({ response }) => {
        // console.log(response, url, "DEBUGA");
      });
  },
  async getElasticResults({ commit, state }, { url, data }) {
    const body = {
      method: "POST",
      url: `${this.$config.ecsApiURL}/${this.$config.ecsTaxIndex}${url}`,
    };

    // if (token) body.headers = { Authorization: `Bearer ${token}` }
    return await this.$axios(body)
      .then((data) => data)
      .catch(({ response }) => {
        // console.log(response, url, "DEBUGA");
      });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
